module.exports = __webpack_public_path__ + "img/amex.b67bdea4.svg";